<div class="header">
    <div class="header-actions" *ngIf="!disabled">
        <div class="search-filter-container"></div>
        <div class="actions-container">
            <txp-button data-qa-label="AddHoursButton"
                        [style]="buttonStyle.SECONDARY"
                        [size]="buttonSize.SMALL"
                        [disabled]="disabled"
                        (click)="addListItem(undefined)">
                {{ 'brand.storeHours.addSpecialHours' | translate }}
            </txp-button>
        </div>
    </div>
</div>

<div class="special-hours-list" [formGroup]="form" formSubmittedSync>
    <div class="special-hours-list-item"
         formArrayName="items"
         *ngFor="let item of form.get('items')['controls']; let i = index;">
        <mat-form-field class="special-hours-date" [formGroupName]="i">
            <mat-label>{{ 'store.storeHours.date' | translate }}</mat-label>
            <div formGroupName="rule">
                <input matInput [matDatepicker]="picker" formControlName="value" required>
            </div>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error>
                {{ 'form.error.required' | translate }}
            </mat-error>
        </mat-form-field>

        <ng-container [formGroupName]="i">
            <mat-slide-toggle class="special-hours-toggle"
                              formControlName="isOpen"
                              data-qa-label="OpenToggle">
                {{ (item.get('isOpen').value ? 'store.storeHours.open' : 'store.storeHours.closed') | translate}}
            </mat-slide-toggle>
        </ng-container>

        <ng-container [formGroupName]="i">
            <ng-container formArrayName="operatingHours">
                <mat-form-field class="special-hours-start-time" [formGroupName]="0">
                    <mat-label>{{ 'brand.storeHours.startTime' | translate }}</mat-label>
                    <input required
                           formControlName="startTime"
                           maxlength="5"
                           matInput/>
                    <mat-hint>{{ 'form.hint.time24HrFormat' | translate }}</mat-hint>
                    <mat-error *ngIf="item.controls.operatingHours.controls[0].get('startTime').errors?.required">
                        {{ 'form.error.required' | translate }}
                    </mat-error>
                    <mat-error *ngIf="item.controls.operatingHours.controls[0].get('startTime').errors?.pattern">
                        {{ 'form.error.invalidTimeFormat' | translate }}
                    </mat-error>
                    <mat-error *ngIf="item.controls.operatingHours.controls[0].get('startTime').errors?.beforeTime">
                            {{ 'form.error.startTimeAfterEndTime' | translate}}
                        </mat-error>
                </mat-form-field>
            </ng-container>
        </ng-container>

        <ng-container [formGroupName]="i">
            <ng-container formArrayName="operatingHours">
                <mat-form-field class="special-hours-end-time" [formGroupName]="0">
                    <mat-label>{{ 'brand.storeHours.endTime' | translate }}</mat-label>
                    <input required
                           formControlName="endTime"
                           maxlength="5"
                           matInput/>
                    <mat-hint>{{ 'form.hint.time24HrFormat' | translate }}</mat-hint>
                    <mat-error *ngIf="item.controls.operatingHours.controls[0].get('endTime').errors?.required">
                        {{ 'form.error.required' | translate }}
                    </mat-error>
                    <mat-error *ngIf="item.controls.operatingHours.controls[0].get('endTime').errors?.pattern">
                        {{ 'form.error.invalidTimeFormat' | translate }}
                    </mat-error>
                    <mat-error *ngIf="item.controls.operatingHours.controls[0].get('endTime').errors?.afterTime">
                            {{ 'form.error.endTimeBeforeStartTime' | translate}}
                        </mat-error>
                </mat-form-field>
            </ng-container>
        </ng-container>
        <button mat-button class="btn-remove" type="button"
                *ngIf="!disabled"
                (click)="removeListItem(i)"><i class="tce-icon-trash"></i></button>
    </div>
</div>
